import React from 'react';
import { ArrowDown, ArrowUp, ArrowUpDown } from 'lucide-react';

/** Sortable <th> cell. Clicking toggles sort direction; clicking another column switches. */
export default function SortHeader({
    label, sortKey, currentSortKey, currentSortDir, onSort,
    align = 'left', className = '', testId,
}) {
    const active = currentSortKey === sortKey;
    const alignCls = align === 'right' ? 'text-right' : align === 'center' ? 'text-center' : 'text-left';
    const justify  = align === 'right' ? 'justify-end' : align === 'center' ? 'justify-center' : 'justify-start';

    return (
        <th className={`${alignCls} font-medium px-4 py-3 ${className}`}>
            <button
                type="button"
                onClick={() => onSort(sortKey)}
                className={`inline-flex items-center gap-1 ${justify} w-full hover:text-[color:var(--bm-text)] transition ${active ? 'text-[color:var(--bm-text)] font-semibold' : ''}`}
                data-testid={testId || `sort-${sortKey}`}
            >
                <span>{label}</span>
                {active
                    ? (currentSortDir === 'asc' ? <ArrowUp size={12} /> : <ArrowDown size={12} />)
                    : <ArrowUpDown size={11} className="opacity-40" />}
            </button>
        </th>
    );
}
